import Utilities                       from '../Utilities';
import AutocompleteStrategy            from './AutocompleteStrategy';

export default class AustraliaAutocompleteStrategy extends AutocompleteStrategy {
    public getCity():string {
        const order = [
            'sublocality_level_1',
            'locality',
            'postal_town',
            'neighborhood',
            'administrative_area_level_2',
            'administrative_area_level_3',
        ];

        return Utilities.getFirstComponentValueByUnsortedType( order, this.components );
    }

    public getState(): string {
        return Utilities.getComponentValueByUnsortedType( 'administrative_area_level_1', this.components );
    }

    public getCountry(): string {
        return Utilities.getComponentValueByUnsortedType( 'country', this.components );
    }
}
